import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './_helpers/auth.guard';

const loginModule = () => import('./login/login.component').then((x) => x.LoginComponent)
const dashboardModule = () => import('./dashboard/dashboard.component').then((x) => x.DashboardComponent)
const factfeedbackModule = () => import('./fact-and-feedback/fact-and-feedback.component').then((x) => x.FactAndFeedbackComponent)
const schememdodule = () => import('./scheme-lists/scheme-lists.component').then((x) => x.SchemeListsComponent)
const schemeDetailsmodule = () => import('./user-scheme-lists/user-scheme-lists.component').then((x) => x.UserSchemeListsComponent)
const customerListsModule = () => import('./customer-list/customer-list.component').then((x)=>x.CustomerListComponent)
const branchListsModule = () => import('./branch-lists/branch-lists.component').then((x)=>x.BranchListsComponent)
const offerListsModule = () => import('./offer-details/offer-details.component').then((x)=>x.OfferDetailsComponent)
const postsModule = () => import('./posts/posts.component').then((x)=>x.PostsComponent)
const reelsModule = () => import('./reels/reels.component').then((x)=>x.ReelsComponent)
const addVideoModule = () => import('./add-video/add-video.component').then((x)=>x.AddVideoComponent)
const scheduledMediaListModule = () => import('./scheduled-media-list/scheduled-media-list.component').then((x)=>x.ScheduledMediaListComponent)

const routes: Routes = [
  {
    path: 'login',
    loadComponent: loginModule
  },
  {
    path: 'customer-list',
    loadComponent: customerListsModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'gold-plan',
    loadComponent: schememdodule,
    canActivate: [AuthGuard]
  },
  {
    path: 'user-gold-plan-detail',
    loadComponent: schemeDetailsmodule,
    canActivate: [AuthGuard]
  },
  {
    path: 'fact-feedback',
    loadComponent: factfeedbackModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'branch',
    loadComponent: branchListsModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'offer',
    loadComponent: offerListsModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'posts',
    loadComponent: postsModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'dashboard',
    loadComponent: dashboardModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'reels',
    loadComponent: reelsModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'add-video',
    loadComponent: addVideoModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'scheduled-media-list',
    loadComponent: scheduledMediaListModule,
    canActivate: [AuthGuard]
  },

  {
    path: '**',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
